module.exports = __webpack_public_path__ + "static/media/boss-bar-red-07.b995c314.png";